export default __webpack_public_path__ + "static/media/log-in.c72559b6.svg";